import { render, staticRenderFns } from "./ChatFrame.vue?vue&type=template&id=7b1b56ca&"
import script from "./ChatFrame.vue?vue&type=script&lang=js&"
export * from "./ChatFrame.vue?vue&type=script&lang=js&"
import style0 from "./ChatFrame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\job_hymn\\hymn-business02\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b1b56ca')) {
      api.createRecord('7b1b56ca', component.options)
    } else {
      api.reload('7b1b56ca', component.options)
    }
    module.hot.accept("./ChatFrame.vue?vue&type=template&id=7b1b56ca&", function () {
      api.rerender('7b1b56ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/ChatFrame.vue"
export default component.exports